export type RequestNewPasswordFormUi = {
  isEmailSubmitted: boolean;
  email: string;
  isSending: boolean;
  isDisabled: boolean;
};

export const initialRequestNewPasswordFormUi: RequestNewPasswordFormUi = {
  isEmailSubmitted: false,
  email: '',
  isSending: false,
  isDisabled: true,
};
